import * as React from "react";
import ReactToPrint from "react-to-print";
import { InboxHeaderConstants } from "src/Core/Common/Constants";
import { PrintDocumentIcon } from "src/assets/images/svg/IconCollection";

interface IPrintMessageProps {
    showPrintText?: boolean;
    printText?: string;
    showPrintIcon?: boolean;
    children?: React.ReactNode;
    spamMessage: boolean;
    resourceId: string;
}
export const PrintComponent: React.FC<IPrintMessageProps> = ({
    showPrintIcon,
    showPrintText,
    printText,
    children,
    spamMessage,
    resourceId,
}) => {
    let componentRef: any = React.useRef();

    return (
        <>
            {/* button to trigger printing of target component */}
            <ReactToPrint
                trigger={() => (
                    <div data-resource-id={resourceId} className={!spamMessage ? "inbox-print-wrapper" : ""}>
                        {showPrintIcon ? <PrintDocumentIcon /> : null}
                        {showPrintIcon && !spamMessage ? <p>{InboxHeaderConstants.PRINT}</p> : null}
                        {showPrintText ? printText : null}
                    </div>
                )}
                content={() => componentRef}
            />

            {/* component to be printed */}
            <div style={{ display: "none" }}>
                {React.Children.map(children, child => {
                    return React.cloneElement(child as React.ReactElement, {
                        ref: (el: any) => (componentRef = el),
                    });
                })}
            </div>
        </>
    );
};
